var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isLoggedin)?_c('Header'):_vm._e(),(_vm.isLoggedin)?_c('Navigation'):_vm._e(),_c('AppMain'),(_vm.isLoggedin)?_c('Footer'):_vm._e(),(_vm.isLoggedin)?_c('MenuPopup'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }